// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5481) return "static/chunks/5481-043a209a0a98e806.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"5051":"406b2ba4","9213":"ef7830f0"}[chunkId] || chunkId) + "." + {"993":"a5f3e42001be511e","1480":"d29f854b0d235682","3635":"b2a2cf6a18cfd5ab","5051":"2085e11621b08cbe","5236":"c1a27a4df8c16342","8835":"394ccc700960dc9d","8903":"349df4f9baace4f0","9213":"3373fd0bdc0fdb12","9669":"63f328067640ca9e"}[chunkId] + ".js";
};